/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
import React, {useEffect, useState} from "react";
import AnalyticsHelper from "../../shared/modules/AnalyticsHelper";
import Helper from "../../shared/modules/Helper";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import PropTypes from "prop-types";

const NonMemberOrderConfirmation = ({addressInfo, sessionId, setDisplayErrors, setError}) => {
  const [
    isLoading,
    setIsLoading
  ] = useState(true);

  const [
    session,
    setSession
  ] = useState(null);

  const {
    "first_name": firstName,
    "last_name": lastName,
    "street_address_1": streetAddressOne,
    "street_address_2": streetAddressTwo
  } = addressInfo;
  const {zip, city, state} = addressInfo;

  const addOwnerListens = () => {
    if (!$(".ol_show").length) {
      const script = document.createElement("script");
      script.src = "https://ownerlistens.com/static/js/ol_sms_box_min.js?mm_id=2hjmkpanlr3iv&v=1.5.11";
      script.type = "text/javascript";
      script.defer = true;
      document.getElementsByTagName("head").item(0).appendChild(script);
    }
  };

  const getSession = async () => {
    const response = await NonMemberCartAPI.getStripeSession(sessionId);

    if (response.success === false) {
      setError({"message": response.error});
      setDisplayErrors(true);
    } else {
      setSession(response);
    }
    setIsLoading(false);
  };

  const openSMSWidget = () => {
    const checkExist = setInterval(() => {
      try {
        if ($(".ol_show").length) {
          const handle = $(".ol-side-box-handle");
          const cta = $(".ol-side-box-cta");
          if (handle.length) {
            handle.trigger("click");
          }
          if (cta.length) {
            cta.trigger("click");
          }
          clearInterval(checkExist);
        }
      } catch (error) {
        clearInterval(checkExist);
      }
    }, 100);
  };

  useEffect(() => {
    addOwnerListens();
    getSession();
  }, []);

  if (!session) return null;

  if (session.payment_status === "paid") {
    AnalyticsHelper.sendPurchasedCartEventForStripe(session.order);
  }

  return (
    <div className="bg-white text-neutral-800">
      <div className="cart-header text-center flex flex-col gap-0 px-4 py-2.5 border-b border-neutral-800">
        <div className="leading-none text-3xl font-serif">
          Thank You
        </div>
        <div className="leading-none text-lg">
          for your purchase!
        </div>
      </div>
      {isLoading &&
      <div className="py-10">
        <LoadingSpinner
          color="#242424"
          size={50}
          width={3}
        />
      </div>}
      {!isLoading && session &&
      <div className="px-4 text-base text-left divide-y divide-neutral-200">
        <section className="py-4 flex flex-col gap-4">
          <div className="font-serif">
            Order Details
          </div>
          <div className="grid grid-cols-2 gap-4 text-wrap break-all leading-tight">
            <div className="font-sans-demibold">
              Order Date
            </div>
            <div>
              {Helper.formatDate(Date.now())}
            </div>
            <div className="font-sans-demibold">
              Shipping To
            </div>
            <div>
              <div>
                {`${firstName} ${lastName}`}
              </div>
              <div>
                {streetAddressOne}
              </div>
              {streetAddressTwo &&
              <div>
                {streetAddressTwo}
              </div>}
              <div>
                {city}
                {", "}
                {state}
                {" "}
                {zip}
              </div>
            </div>
            <div className="font-sans-demibold">
              Billed To
            </div>
            <div>
              <div>
                {session.customer_details.name}
              </div>
              <div>
                {session.customer_details.email}
              </div>
            </div>
            <div className="font-sans-demibold">
              Payment Method
            </div>
            <div className="capitalize">
              {session.payment_method.card.brand}
              {" •••• "}
              {session.payment_method.card.last4}
            </div>
          </div>
        </section>
        <section className="py-4 flex flex-col gap-4">
          <div className="font-serif">
            What You Ordered
          </div>
          <div>
            {session.line_items.data.map(item =>
              <div
                className="flex gap-8 item-center"
                key={item.id}
              >
                <div>
                  <img
                    className="max-w-32 w-32 h-auto"
                    src={item.price.product.metadata.image}
                  />
                </div>
                <div className="flex flex-col gap-0 text-sm justify-center">
                  <div>
                    {item.price.product.metadata.designer}
                  </div>
                  <div className="text-base font-serif mb-1">
                    {item.price.product.metadata.name}
                  </div>
                  <div className="flex gap-1.5">
                    Price:
                    {" "}
                    $
                    {item.quantity === 1 ? Helper.formatPriceCents(item.price.unit_amount)
                      : Helper.formatPriceCents(item.price.unit_amount * item.quantity)}
                    {item.quantity > 1 &&
                    <span className="text-neutral-500">
                      ($
                      {Helper.formatPriceCents(item.price.unit_amount)}
                      {" x "}
                      {item.quantity}
                      )
                    </span>}
                  </div>
                  <div>
                    Qty:
                    {" "}
                    {item.quantity}
                  </div>
                </div>
              </div>)}
          </div>
          <div />
        </section>
        <section className="py-4 flex flex-col gap-4">
          <div className="font-serif">
            Order Summary
          </div>
          <div className="grid grid-cols-2 gap-4 leading-tight">
            <div>
              Subtotal
            </div>
            <div className="text-right">
              {`$${Helper.formatPriceCents(session.totals.subtotal)}`}
            </div>
            <div>
              Shipping
            </div>
            <div className="text-right">
              {!session.shipping_cost &&
              <span className="text-tangerine-100">
                FREE
              </span>}
            </div>
            <div>
              Estimated Sales Tax
            </div>
            <div className="text-right">
              {`$${Helper.formatPriceCents(session.totals.total_tax)}`}
            </div>
            <div className="font-sans-demibold">
              Total
            </div>
            <div className="text-right">
              {`$${Helper.formatPriceCents(session.totals.total)}`}
            </div>
            {Boolean(session.totals.total_discount) &&
            <div className="col-span-2 grid grid-cols-2 gap-4">
              <div>
                Total Discount
              </div>
              <div className="text-right">
                <span className="text-tangerine-100">
                  {`$${Helper.formatPriceCents(session.totals.total_discount)}`}
                </span>
              </div>
            </div>}
          </div>
        </section>
        <section className="py-8 text-center">
          <div className="font-serif text-lg leading-none">
          Questions?
          </div>
          <div className="mt-2.5">
            <a
              className="underline"
              // eslint-disable-next-line react/jsx-no-bind
              onClick={openSMSWidget}
              role="button"
            >
            Send us a text
            </a>
            {" "}
            or call
            {" "}
            <a
              aria-label="Call 1-877-478-0450 for assistance"
              className="underline"
              // eslint-disable-next-line react/jsx-no-bind
              onClick={openSMSWidget}
              role="button"
            >
              1-877-478-0450
            </a>
          </div>
          <div className="text-neutral-500 italic">
          Mon-Fri 10am-7pm EST, Closed on Sat-Sun
          </div>
        </section>
        <section className="py-4 flex flex-col gap-2">
          <a
            className="button-primary"
            href="/jewelry"
          >
            Keep Shopping
          </a>
          <a
            className="mt-4 button-outlined-white"
            href="/jewelry"
          >
            Shop All
          </a>
          <a
            className="button-outlined-white"
            href="/jewelry?sort-best_selling"
          >
            Best Sellers
          </a>
          <a
            className="button-outlined-white"
            href="/jewelry?my_rocksbox-new_arrivals"
          >
            New Arrivals
          </a>
        </section>
      </div>}
    </div>
  );
};

NonMemberOrderConfirmation.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "sessionId": PropTypes.string.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired
};

export default NonMemberOrderConfirmation;
